module.exports = __webpack_public_path__ + "static/Icons_ReverseMortgage_small_Active copy-b801317153c68612d512729c206b62b6.png";